export const files = {
  install: './files/Installation instructions.pdf',
  manual: './files/Manual.pdf',
  functional:'./files/Description of functional characteristics.pdf',
  processes: './files/Life cycle processes.pdf',
  prFiles: './files/flash-media/flashmedia.zip',
  about: './files/Information about the software registry.pdf',
  flashclient: './files/overcome_flashclient.pdf' 
}